import { useGetGroupOrderQuery } from "../../../../../../../../../services/PerformanceHistory/performanceHistoryAPI";
import { PerfHistoryDataProps } from "../ABOProfilePerfHistoryKPIs";

const ABOProfilePerfHistoryGroupOrder = ({
  affAbo,
  locale,
  isoCountryCode,
  period,
  periodCount = 12,
  children,
}: PerfHistoryDataProps) => {
  const { isFetching, data, isError } = useGetGroupOrderQuery({
    affAbo,
    period,
    periodCount,
    locale,
    market: isoCountryCode,
  });

  return <>{children({ data, isFetching, isError })}</>;
};

export default ABOProfilePerfHistoryGroupOrder;
